import client from './client';
import { ISkuListItem, ISkuDetail } from '@/types/api-responses';

/**
 * Список SKU для каталога и sitemap.
 * Используется для:
 * - алфавитного указателя (параметр `letter`);
 * - построения sitemap (пагинация `from`/`count`);
 * - дельта-обновлений (`updated_after`).
 */
export async function getSkus(params?: {
  letter?: string;
  from?: number;
  count?: number;
  updated_after?: string;
  region?: number;
}): Promise<ISkuListItem[]> {
  const { data } = await client.GET('/api/v1/public/products/skus', {
    params: {
      query: {
        letter: params?.letter,
        from: params?.from,
        count: params?.count,
        updatedAfter: params?.updated_after,
        region: params?.region,
      },
    },
  });
  return (data ?? []) as unknown as ISkuListItem[];
}

/**
 * Детальная карточка SKU по slug.
 * Альтернатива `getSkuById` — используется, когда в URL приходит slug, а не ID.
 */
export async function getSkuBySlug(slug: string, region?: number): Promise<ISkuDetail | null> {
  const { data, error } = await client.GET('/api/v1/public/products/by-slug/{slug}', {
    params: {
      path: { slug },
      query: { region },
    },
  });
  if (error) return null;
  return data as unknown as ISkuDetail;
}
